import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';

export function CommentButton({ handleClick, commentsCount }) {
  return (
    <button
      onClick={handleClick}
      className="inline-flex flex-1 items-center justify-center gap-1 rounded-xl p-2 hover:bg-indigo-300/40 hover:text-indigo-800 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-100"
    >
      <Icon className="h-[1.3em] w-[1.3em]" icon="akar-icons:comment" />
      <div>
        {commentsCount}{' '}
        <span className="max-[299px]:hidden">
          {' '}
          {commentsCount <= 1 ? 'comment' : 'comments'}
        </span>
      </div>
    </button>
  );
}

CommentButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  commentsCount: PropTypes.number.isRequired,
};
